/**
 * Store de versiones con Zustand
 * Sprint 6: Estado global para control de versiones obligatorias
 *
 * Flujo:
 *   1. App.tsx llama checkVersion() al montar
 *   2. Si updateRequired === true → pantalla bloqueante
 *   3. Si falla la consulta → no bloquea (updateRequired = false)
 */

import { create } from 'zustand';
import { versionService } from '../services/version';
import { APP_VERSION } from '../config/version';

interface VersionState {
    // Estado
    localVersion: string;
    minimumVersion: string | null;
    currentVersion: string | null;
    downloadUrl: string | null;
    updateRequired: boolean;
    isLoading: boolean;
    error: string | null;

    // Acciones
    checkVersion: () => Promise<void>;
}

export const useVersionStore = create<VersionState>((set, get) => ({
    // Estado inicial
    localVersion: APP_VERSION,
    minimumVersion: null,
    currentVersion: null,
    downloadUrl: null,
    updateRequired: false,
    isLoading: true, // empieza en true: la app muestra splash hasta que se resuelva
    error: null,

    checkVersion: async () => {
        set({ isLoading: true, error: null });

        try {
            const result = await versionService.checkVersion(get().localVersion);

            set({
                minimumVersion: result.minimumVersion,
                currentVersion: result.currentVersion,
                downloadUrl: result.downloadUrl,
                updateRequired: result.updateRequired,
                isLoading: false,
            });
        } catch (error) {
            console.error('[versionStore] Error checking version:', error);

            // En caso de error de red NO bloqueamos la app
            set({
                error: 'No se pudo verificar la versión de la aplicación.',
                isLoading: false,
                updateRequired: false,
            });
        }
    },
}));
